import React, { useMemo } from "react";

const Pill = ({ text, tone = "info" }) => {
  const map = {
    info: { bg: "#EFF8FF", fg: "#175CD3" },
    neutral: { bg: "#EEF2FF", fg: "#3730A3" },
    good: { bg: "#ECFDF3", fg: "#027A48" },
    warn: { bg: "#FFFAEB", fg: "#B54708" },
    bad: { bg: "#FEF3F2", fg: "#B42318" },
  };
  const c = map[tone] || map.info;

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 999,
        background: c.bg,
        color: c.fg,
        fontSize: 12,
        fontWeight: 900,
        border: "1px solid rgba(0,0,0,0.04)",
        letterSpacing: 0.2,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
};

export default function SSBReportShell({
  title,
  subtitle,
  leftMeta = [],
  rightMeta = [],
  children,
  footerLeft,
  footerRight,
  showLastRefreshed = true,
}) {
  const refreshedText = useMemo(() => {
    if (!showLastRefreshed) return null;
    const d = new Date();
    return `Last refreshed: ${d.toLocaleString()}`;
  }, [showLastRefreshed]);

  return (
    <div
      style={{
        padding: 18,
        background: "#F3F6FB",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(90deg, #0B3A6E 0%, #164E86 60%, #1F63A8 100%)",
          color: "white",
          borderRadius: 18,
          padding: "14px 16px",
          boxShadow: "0 18px 60px rgba(11,58,110,0.22)",
          marginBottom: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 260 }}>
          <div style={{ fontSize: 18, fontWeight: 950, letterSpacing: 0.2 }}>{title}</div>
          <div style={{ fontSize: 12, opacity: 0.92, marginTop: 4 }}>{subtitle}</div>
          {refreshedText ? (
            <div style={{ fontSize: 11, opacity: 0.85, marginTop: 6 }}>{refreshedText}</div>
          ) : null}
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
          {rightMeta.map((m, idx) => (
            <Pill key={idx} text={m} tone="info" />
          ))}
        </div>
      </div>

      {/* Meta row (chips) */}
      {leftMeta.length > 0 ? (
        <div
          style={{
            background: "#FFFFFF",
            border: "1px solid #E7ECF3",
            borderRadius: 16,
            padding: 10,
            boxShadow: "0 10px 30px rgba(16,24,40,0.06)",
            marginBottom: 12,
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {leftMeta.map((m, idx) => (
              <Pill key={idx} text={m} tone="neutral" />
            ))}
          </div>

          {/* show source ONLY here OR footer, not both */}
          {footerRight ? (
            <div style={{ fontSize: 12, color: "#64748B" }}>{footerRight}</div>
          ) : null}
        </div>
      ) : null}

      {/* Content */}
      {children}

      {/* Footer */}
      <div
        style={{
          marginTop: 14,
          display: "flex",
          justifyContent: "space-between",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        <div style={{ fontSize: 12, color: "#64748B" }}>{footerLeft}</div>
        {/* Hide footerRight here to avoid duplication (it appears in meta row) */}
      </div>
    </div>
  );
}